import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import TabContext from "../contexts/TabContext"
import MenuContext from "../contexts/MenuContext"
import "./Footer.scss"

const Footer = () => {
  const { tabSelected, hideTabs, setTabSelected } = React.useContext(TabContext)
  const { setModalOrderPreview, modalOrderPreview } = React.useContext(MenuContext)

  if (hideTabs) {
    return ""
  }

  const menuItems = [
    {
      key: "home",
      icon: "house",
      label: "Início",
      onClick: () => setTabSelected("home"),
      isActive: tabSelected === "home",
    },
    {
      key: "cart",
      icon: "cart-shopping",
      label: "Carrinho",
      onClick: () => setModalOrderPreview(true),
      isActive: modalOrderPreview,
    },
    {
      key: "profile",
      icon: "user",
      label: "Perfil",
      onClick: () => setTabSelected("profile"),
      isActive: tabSelected === "profile",
    },
  ]

  return (
    <footer className="section-footer">
      <div className="section-footer--container">
        {menuItems.map((item) => (
          <button
            key={item.key}
            className={`section-footer--menu-item ${item.isActive ? "active" : ""}`}
            onClick={item.onClick}
            aria-label={item.label}
          >
            <div className="section-footer--menu-item--icon">
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <span className="section-footer--menu-item--label">{item.label}</span>
          </button>
        ))}
      </div>
    </footer>
  )
}

export default Footer
